import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `CarouselItemDirective` represent a item of the React Carousel.
 * It must be contained in a Carousel component(`CarouselComponent`).
 * ```tsx
 * <CarouselComponent>
 *   <CarouselItemsDirective>
 *    <CarouselItemDirective template='#item1'></CarouselItemDirective>
 *    <CarouselItemDirective template='#item2'></CarouselItemDirective>
 *   </CarouselItemsDirective>
 * </CarouselComponent>
 * ```
 */
export class CarouselItemDirective extends ComplexBase {
}
CarouselItemDirective.moduleName = 'carouselItem';
export class CarouselItemsDirective extends ComplexBase {
}
CarouselItemsDirective.propertyName = 'items';
CarouselItemsDirective.moduleName = 'carouselItems';
